import * as React from 'react';
export const DESvg = React.forwardRef(function DESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 12.4V10h16v2.4c0 .884-.682 1.6-1.524 1.6H1.524C.682 14 0 13.284 0 12.4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        d: 'M15 10v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2H0v2c0 1.392.476 2 2 2h12c1.579 0 2-.733 2-2v-2h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M16 3.6V6H0V3.6C0 2.716.682 2 1.524 2h12.952C15.318 2 16 2.716 16 3.6Z',
      }),
    ),
  );
});
DESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var DE = {
  category: 'flag',
  colorable: false,
  name: 'DE',
  svg: DESvg,
};
